exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-wrapper___3BSKi {\n  padding: 60px;\n}\n.title___20l45 {\n  color: #21201f;\n  font-family: \"proxima-nova\", 'Helvetica', Arial, sans-serif;\n  font-size: 32px;\n  font-stretch: normal;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: -0.29px;\n  line-height: normal;\n  margin: 0;\n}\n.text___1CQSc {\n  color: #21201f;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 20px 0;\n}\n.mention___5urEV {\n  color: #767676;\n  font-size: 14px;\n}\n.chart___1jNfH {\n  border: solid 2px #d9d9d9;\n  margin: 0 0 10px;\n  text-align: center;\n  width: 100%;\n}\n.chart__header___vxm6V {\n  background: #fafafa;\n}\n.chart__header__content___mLah_ {\n  border: solid 2px #d9d9d9;\n  font-size: 14px;\n  padding: 15px 10px;\n  text-align: center;\n  color: #21201f;\n}\n.chart__body___2Bp6p {\n  background: #fff;\n}\n.chart__body__content___1Yvli {\n  border: solid 2px #d9d9d9;\n  font-size: 14px;\n  padding: 15px 10px;\n  text-align: center;\n  color: #505050;\n}\n", ""]);

// exports
exports.locals = {
	"content-wrapper": "content-wrapper___3BSKi",
	"title": "title___20l45",
	"text": "text___1CQSc",
	"mention": "mention___5urEV",
	"chart": "chart___1jNfH",
	"chart__header": "chart__header___vxm6V",
	"chart__header__content": "chart__header__content___mLah_",
	"chart__body": "chart__body___2Bp6p",
	"chart__body__content": "chart__body__content___1Yvli"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/modals/ExpeditedShippingModal/ExpeditedShippingModal.module.less
// module id = 1704
// module chunks = 71